import axios from ".";
/** Get closed risks/issues for an entity by id. */
export const getIssueRisk = (id: number) => {
  return axios({
    method: "GET",
    url: `/risk/closed/${id}`,
  });
};

/** Create a new risk/issue. */
export const addIssueRisk = (data: any) => {
  return axios({
    method: "POST",
    url: `/risk/create`,
    data: data,
  });
};

/** Update risk/issue by id. */
export const updateIssueRisk = (id: number, data?: any) => {
  return axios({
    method: "PUT",
    url: `/risk/update/${id}`,
    data: data,
  });
};

/** Delete risk/issue by id. */
export const deleteIssueRiskByID = (id: number | null) => {
  return axios({
    method: "DELETE",
    url: `/risk/delete/${id}`,
  });
};
